<template>
  <div class="offline">
    <div class="title">
      <p>
        <span>设备离线</span>
      </p>
    </div>
    <div class="content">
      <!--搜索-->
      <!--      <div v-if="!props.value" class="searchBox">-->
      <!--        <div class="liBox">-->
      <!--          <span style="margin-right: 8px">设备通讯地址</span>-->
      <!--          <el-input v-model="address" clearable placeholder="请输入通讯地址"></el-input>-->
      <!--        </div>-->
      <!--        <div class="liBox">-->
      <!--          <el-button class="searchButton" type="primary" @click="searchFun">查询</el-button>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--数据列表内容-->
      <div class="contain">
        <!--报警列表-->
        <el-table v-loading="loading" :data="tableData" style="width: 100%" table-layout="auto">
          <template #empty>
            <el-empty class="emptyClass" description="暂无数据信息" image="
https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png">
            </el-empty>
          </template>
          <el-table-column label="设备名称" prop="equipmentName"/>
          <el-table-column label="离线时间" prop="createTime" sortable/>
          <!--          <el-table-column label="重新上线时间" prop="onTime" sortable/>-->
        </el-table>
        <div class="pag">
          <el-pagination v-show="tableData.length > 0" v-model:page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
                         :total="total" background layout="total,sizes,prev, pager, next"
                         @size-change="handleSizeChange"
                         @current-change="pageChange"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import './deviceOffline.less'
import {onMounted, ref} from "vue"
import {ElMessage} from 'element-plus'
import {useRouter} from 'vue-router';
import {getEquipmentOfflineRecordApi} from '@/api/modules/alarm'
import qs from "qs";

const props = defineProps({
  value: String
})
let router = useRouter()

// 报警-----------------------------------------------------------------------
// 分页
let pageNumber = ref(1)
let pageSize = ref(20)
let total = ref()
// 更改每页多少
const handleSizeChange = function (e) {
  pageSize.value = e
  getListFun()
}
// 跳转到某页
const pageChange = function (e) {
  pageNumber.value = e
  getListFun()
}
// 报警表格数据
let tableData = ref([])
// 获取报警列表
let loading = ref(false)
const getListFun = function () {
  loading.value = true
  getEquipmentOfflineRecordApi(qs.stringify({
    pageNumber: pageNumber.value,
    pageSize: pageSize.value,
    // gatewayId: props.value,
    // address: address.value
  })).then(res => {
    loading.value = false
    if (res.data.code === 0) {
      tableData.value = res.data.result.list
      total.value = Number(res.data.result.total)
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}

// 查询
let address = ref() //通讯地址
const searchFun = function () {
  getListFun()
}

onMounted(() => {
  getListFun()
})

</script>

<style lang="less" scoped>
//搜索
:deep(.searchBox) {
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.09);
}

//主体
:deep(.contain) {
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.09);
}

/*:deep(.is-first) {
  margin-right: 19px !important;
}*/

</style>
